module.exports = __webpack_public_path__ + "img/1.e4f0a940.jpg";